module.exports = __webpack_public_path__ + "static/media/tea-pouch-icon.85436cbc.svg";